export const REGIONEAEREOARRIVO = 'REGIONEAEREOARRIVO'